import { AvaStore } from '@models';
export type CsvRow = { [key: string]: any };

const compareOpeningHours = (store: AvaStore, csvRow: CsvRow) => {
  const daysOfWeek = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
  const isOpeningHoursMatch = daysOfWeek.every((day) => {
    const storeOpen = store.opening_hours.find((item) => item.day === day);
    const csvOpen = csvRow[`${day}_open`];
    const csvClosed = csvRow[`${day}_closed`];

    if (!storeOpen || !csvOpen || !csvClosed) {
      return false;
    }

    if (storeOpen.open !== csvOpen || storeOpen.closed !== csvClosed) {
      return false;
    }

    return true;
  });
  return isOpeningHoursMatch;
};

const compareStoreProperties = (store: AvaStore, csvRow: CsvRow) => {
  if (
    store.address?.address_line_1 !== csvRow.address_line_1 ||
    store.address?.geo?.lat !== parseFloat(csvRow.lat) ||
    store.address?.geo?.lng !== parseFloat(csvRow.lng) ||
    store.address?.postcode !== Number(csvRow.postcode) ||
    store.address?.state !== csvRow.state ||
    store.address?.suburb !== csvRow.suburb ||
    store.is_trading !== (csvRow.is_trading === 'TRUE') ||
    store.name !== csvRow.name ||
    !compareOpeningHours(store, csvRow) ||
    store.store_type !== csvRow.store_type
  ) {
    return false;
  } else {
    return true;
  }
};

const compareStores = (stores: AvaStore[], csvRows: CsvRow[]) => {
  const updated = csvRows
    .map((csvStore) => {
      const originalStore = stores.find((s) => s.store_code === csvStore.store_code);

      if (originalStore) {
        const isEqualStores = compareStoreProperties(originalStore, csvStore);

        if (!isEqualStores) {
          return {
            name: csvStore['name'],
            store_code: csvStore['store_code'],
            is_trading: csvStore['is_trading'],
            store_type: csvStore['store_type'],
            address: {
              address_line_1: csvStore['address_line_1'],
              suburb: csvStore['suburb'],
              postcode: Number(csvStore['postcode']),
              state: csvStore['state'],
              geo: {
                lat: Number(csvStore['lat']),
                lng: Number(csvStore['lng']),
              },
            },
            skus: originalStore.skus,
            opening_hours: [
              { day: 'Monday', open: csvStore['Monday_open'], closed: csvStore['Monday_closed'] },
              { day: 'Tuesday', open: csvStore['Tuesday_open'], closed: csvStore['Tuesday_closed'] },
              { day: 'Wednesday', open: csvStore['Wednesday_open'], closed: csvStore['Wednesday_closed'] },
              { day: 'Thursday', open: csvStore['Thursday_open'], closed: csvStore['Thursday_closed'] },
              { day: 'Friday', open: csvStore['Friday_open'], closed: csvStore['Friday_closed'] },
              { day: 'Saturday', open: csvStore['Saturday_open'], closed: csvStore['Saturday_closed'] },
              { day: 'Sunday', open: csvStore['Sunday_open'], closed: csvStore['Sunday_closed'] },
            ],
            cluster: originalStore.cluster,
          };
        }
      } else {
        return {
          name: csvStore['name'],
          store_code: csvStore['store_code'],
          is_trading: csvStore['is_trading'],
          store_type: csvStore['store_type'],
          address: {
            address_line_1: csvStore['address_line_1'],
            suburb: csvStore['suburb'],
            postcode: Number(csvStore['postcode']),
            state: csvStore['state'],
            geo: {
              lat: Number(csvStore['lat']),
              lng: Number(csvStore['lng']),
            },
          },
          skus: [],
          opening_hours: [
            { day: 'Monday', open: csvStore['Monday_open'], closed: csvStore['Monday_closed'] },
            { day: 'Tuesday', open: csvStore['Tuesday_open'], closed: csvStore['Tuesday_closed'] },
            { day: 'Wednesday', open: csvStore['Wednesday_open'], closed: csvStore['Wednesday_closed'] },
            { day: 'Thursday', open: csvStore['Thursday_open'], closed: csvStore['Thursday_closed'] },
            { day: 'Friday', open: csvStore['Friday_open'], closed: csvStore['Friday_closed'] },
            { day: 'Saturday', open: csvStore['Saturday_open'], closed: csvStore['Saturday_closed'] },
            { day: 'Sunday', open: csvStore['Sunday_open'], closed: csvStore['Sunday_closed'] },
          ],
        };
      }
    })
    .filter(Boolean);
  return updated;
};

export { compareStores };
